export default {
  title: 'Les Avantages Nextories',
  subtitle: 'Transfert de vos contrats',
  message: {
    accepted: 'Votre demande de traitement prioritaire a bien été prise en compte.',
    declined: 'Votre souhait de ne pas être recontacté a bien été enregistré.',
  },
  presentation: {
    text1: `Notre service inclus la <b>prise en charge gratuite du transfert de tous vos contrats :
            électricité, internet, assurances</b>.
            C’est l’occasion idéale d’optimiser vos dépenses, grâce à un large panel de fournisseurs, tout en gagnant du temps.
            Au revoir les hotlines et bonjour le wifi en arrivant dans votre nouveau chez vous !`,
    text2: `Notre partenaire se charge de toutes les démarches pour vous. <b>Vous serez contacté quelques
            semaines avant votre déménagement</b>, mais vous avez la possibilité de vous en occuper dès a présent 
            via un traitement prioritaire.`,
    text3: '<b>Et tout ça, gratuitement !</b>',
  },
  confirmNoContracts: {
    title: 'Se désinscrire du service de transfert',
    text: 'Êtes vous sûr de vouloir vous désinscrire du service de transfert de contrats ?',
  },
  contracts: {
    choices: {
      yes: 'Rappelez-moi en priorité',
      no: '&#10006; Je refuse d’être recontacté par le ou les partenaires de Nextories.',
    },
    decline_text: 'Vous pouvez aussi faire le choix de refuser cette prestation et ne pas être contacté.',
    btn: 'Valider',
  },
  partner: {
    title: 'LES PARTENAIRES DE VOTRE DÉMÉNAGEMENT',
    text: 'Nous sommes bien placés pour savoir que déménager n\'est pas qu\'une affaire de cartons ! Nous avons donc négocié, pour vous, des avantages exclusifs chez les meilleures acteurs du marché pour vous accompagner dans vos projets. Il vous suffit de cliquer sur les liens ci-dessous pour en bénéficier !',
    buttonMore: 'EN SAVOIR PLUS',
    buttonLess: 'EN SAVOIR PLUS',
    buttonTakeAdvantage: 'J\'en profite',
  },
};
